function isBuyButtonVisible(element) {
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function toggleStickyForm() {
  const stickyForm = document.getElementById('shopify-section-sticky-quick-add');
  const elementTarget = document.querySelector('.block-buy_buttons product-form');

  if (!stickyForm || !elementTarget) return;

  if (isBuyButtonVisible(elementTarget)) {
    stickyForm.classList.add('sticky-form-hidden');
  } else {
    stickyForm.classList.remove('sticky-form-hidden');
  }
}

window.addEventListener('scroll', toggleStickyForm);
window.addEventListener('DOMContentLoaded', toggleStickyForm);
